module.exports = __webpack_public_path__ + "static/media/js.866548f3.jpeg";